/* eslint-disable import/prefer-default-export */
export { default as Share } from './Share';
